export default __webpack_public_path__ + "static/media/sm-img-perfil.a5f9ed1f.png";